var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"module-block",class:{ 'is-moble': _vm.$store.getters.isMobile, 'no-padding': _vm.noPadding },style:(_vm.getStyle)},[_c('div',{staticClass:"module-block__content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }